var am4ColorThemes = require('./color-themes');
var am4Legend = require('./components/legend');

function hideCategoryLabelText(series) {
	series.ticks.template.disabled = true;
	series.alignLabels = false;
	series.labels.template.text = '{value.percent.formatNumber("#.")}%';
	series.labels.template.radius = window.am4core.percent(5);
}

function showCategoryLabelText(series) {
	series.ticks.template.disabled = false;
	series.alignLabels = true;
	series.labels.template.text = '{category}';
	series.labels.template.radius = window.am4core.percent(5);
}

function hideSmallLabelsAtPercent(percent, series) {
	series.ticks.template.adapter.add('hidden', hideSmallLabels);
	series.labels.template.adapter.add('hidden', hideSmallLabels);

	function hideSmallLabels(hidden, target) {
		return target.dataItem.values.value.percent < percent ? true : false;
	}
}

function createPieSeries(chart, value, showSmallSectionLabel) {
	var series = chart.series.push(new window.am4charts.PieSeries());
	series.dataFields.value = value;
	series.slices.template.stroke = window.am4core.color('#f8f8f8');
	series.slices.template.strokeWidth = 2;
	series.slices.template.strokeOpacity = 1;
	series.slices.template.hoverOnFocus = true;
	series.colors.list = chart.colors.list;
	series.labels.template.maxWidth = 150;
	series.labels.template.wrap = true;
	series.labels.template.text = '{category}';
	series.legendSettings.valueText = '{value.percent.formatNumber("#.")} %';
	series.slices.template.tooltipText = '{category}: {value.percent.formatNumber("#.")} %';
	chart.innerRadius = window.am4core.percent(42);

	if (!showSmallSectionLabel) {
		hideSmallLabelsAtPercent(5, series);
	}

	chart.events.on('sizechanged', function (ev) {
		if (ev.target.pixelWidth < 500) {
			hideCategoryLabelText(series);
		} else {
			showCategoryLabelText(series);
		}
	});
}

module.exports = {
	createPieChart: function ($graphblock, data) {
		var chart = window.am4core.create($graphblock.attr('id'), window.am4charts.PieChart);
		var series = $graphblock.data('chartdata').Series;
		var hideLegend = $graphblock.data('hidelegend').toLowerCase() === 'true';
		var showSmallSectionLabel = $graphblock.data('showsmallsectionlabel').toLowerCase() === 'true';
		chart.data = data;

		chart.colors.list = am4ColorThemes.getChartColorTheme($graphblock.data('charttype'));
		chart.paddingTop = 40;

		if (!hideLegend) {
			am4Legend.createLegend(chart);
			chart.legend.valueLabels.template.width = 35;
		}

		chart.focusFilter.stroke = window.am4core.color('#f59a00');
		chart.focusFilter.strokeWidth = 6;

		for (var i = 0; i < series.length; i++) {
			createPieSeries(chart, series[i].Name, showSmallSectionLabel);
		}

		return chart;
	}
};
